import Control from "sap/ui/core/Control";
import RenderManager from "sap/ui/core/RenderManager";
import { MetadataOptions } from "sap/ui/core/Element";
import Icon from "sap/ui/core/Icon";
import { OrderDeliveryStatus } from "vamos/cockpit/model/odata/VamosModel";

/**
 * @namespace vamos.cockpit.data.goodsreceipt.control
 */
export default class OrderStatusIcon extends Control {


  static readonly metadata: MetadataOptions = {
    properties: {
      statusOfDelivery: {
        type: "any",
        defaultValue: "",
      },
    },
    aggregations: {
      _icon: {
        type: "sap.ui.core.Icon",
        multiple: false,
        visibility: "hidden",
      },
    },
  };

  private _resolveStatusOfDelivery(statusOfDelivery: OrderDeliveryStatus): void {
    let path = "";
    let color = "";
    if (statusOfDelivery === OrderDeliveryStatus.OVERDUE) {
      path = "sap-icon://hint";
      color = "red";
    } else if (statusOfDelivery === OrderDeliveryStatus.PARTIAL_DELIVERED) {
      path = "sap-icon://shipping-status";
      color = "#ffcc00";
    } else if (statusOfDelivery === OrderDeliveryStatus.FULL_DELIVERED) {
      path = "sap-icon://shipping-status";
      color = "green";
    }
    const icon: Icon = this.getAggregation("_icon") as Icon;
    icon.setSrc(path);
    icon.setColor(color);
  }


  public setStatusOfDelivery(statusOfDelivery: any) {
    this.setProperty("statusOfDelivery", statusOfDelivery, true);
    this._resolveStatusOfDelivery(statusOfDelivery as OrderDeliveryStatus);
  }

  init(): void {
    this.setAggregation("_icon", new Icon());
  }

  renderer = {
    apiVersion: 4,
    render: (rm: RenderManager, control: OrderStatusIcon) => {
      rm.renderControl(control.getAggregation("_icon") as Control);
    },
  };
};